module.exports = __webpack_public_path__ + "intern-white-bg.1S5crhzk.png";